import {axi} from '@shared/api';
import {CountryCode} from '../types';

export const getCountryCodes = async (): Promise<CountryCode[]> => {
  const response = await axi.get<{code: string; created_at: string}[]>(
    '/admin/country-code-whitelist',
  );
  return (response.data ?? []).map(item => ({
    countryCode: item.code,
    createdAt: item.created_at ?? null,
  }));
};

export const addCountryCode = async (countryCode: string): Promise<void> => {
  await axi.post('/admin/country-code-whitelist', {country_code: countryCode});
};

export const deleteCountryCode = async (countryCode: string): Promise<void> => {
  await axi.delete(`/admin/country-code-whitelist/${countryCode}`);
};
